import React from 'react'
import ReactDOM from 'react-dom'
import { store, history } from './store'
import Root from './containers/Root'
import { authLoginSuccess } from './actions/auth'
import { tracker } from './utils/tracker'

const target = document.getElementById('root')

const root = (
  <Root store={store} history={history} />
)

const token = localStorage.getItem('token')
if (token !== null) {
  store.dispatch({ ...authLoginSuccess(token), fromStorage: true })
}

// Track page views on every route change.
// The tracker will no-op if the user is not yet identified.
history.listen(location => {
  tracker.track('PAGE_VIEW', location.pathname, document.title)
})

// Defensive global guard: wrap removeChild to avoid uncaught NotFoundError when
// multiple code paths attempt to remove the same node. This prevents the app
// crashing while we progressively harden specific callers.
try {
  const _origRemoveChild = Node.prototype.removeChild
  Node.prototype.removeChild = function (child) {
    try {
      return _origRemoveChild.call(this, child)
    } catch (err) {
      // Only swallow NotFoundError (attempting to remove a non-child)
      // Re-throw other errors to avoid masking real problems.
      if (err && err.name === 'NotFoundError') {
        // eslint-disable-next-line no-console
        console.warn('Ignored removeChild NotFoundError', err, { parent: this, child })
        return null
      }
      throw err
    }
  }
} catch (e) {
  // If prototyping fails for any environment, ignore and continue.
}

ReactDOM.render(root, target)
